import { render } from "./ActivityTemplateVideo.vue?vue&type=template&id=57db6abc"
import script from "./ActivityTemplateVideo.vue?vue&type=script&lang=js"
export * from "./ActivityTemplateVideo.vue?vue&type=script&lang=js"

import "./ActivityTemplateVideo.vue?vue&type=style&index=0&id=57db6abc&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__